import { Navigate, Outlet } from 'react-router-dom'

import useHasVoipOrgFeature from '~/features/organizations/hooks/useHasVoipOrgFeature'
import { EClientPath } from '~/models/api'

function VoipOrgFeatureRoute() {
  const hasVoipOrgFeature = useHasVoipOrgFeature()

  if (!hasVoipOrgFeature) {
    return <Navigate to={EClientPath.overview} replace />
  }

  return <Outlet />
}

export default VoipOrgFeatureRoute
